import { CardContent, Checkbox, FormControlLabel, Box, Typography } from '@material-ui/core';
import config from '../../../config';

function PaymentNotifications({ bookingNotification, setBookingNotification }) {
    const handleNotificationEventValue = (field, value) => {
        let bookingNotifications = [...bookingNotification];
        if (!bookingNotifications.includes(field) && value) {
            bookingNotifications.push(field);
        }
        if (!value) {
            bookingNotifications = bookingNotifications.filter(e => e !== field);
        }
        setBookingNotification(bookingNotifications);
    };
    return (
        <CardContent>
            <h2>Notifications</h2>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={bookingNotification.includes('email') || false}
                        onChange={ev => handleNotificationEventValue('email', !!ev.target.checked)}
                    />
                }
                label="email"
            />
            <Box>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={bookingNotification.includes('sms') || false}
                            onChange={ev =>
                                handleNotificationEventValue('sms', !!ev.target.checked)
                            }
                        />
                    }
                    label="sms"
                />
                <Box ml={1}>
                    <Typography variant="caption" color="text.secondary">
                        By checking this box, you agree to receive SMS from <b>Activiter</b>. Msg &
                        data rates may apply. Msg frequency varies. Reply <b>STOP</b> to opt out.{' '}
                        <a
                            href={`${config.assetsUrl}/termsandconditions.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Terms & Conditions
                        </a>
                    </Typography>
                </Box>
            </Box>
        </CardContent>
    );
}

export default PaymentNotifications;
